import React, { useState} from 'react';
import {
  Container,
  Tabs,
  Tab,
  Form,
  Button,
  Row,
  Col,
  Card,
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
function AuthPage({ onLogin }) {
  const [activeTab, setActiveTab] = useState('login'); // State for active tab
  const [user, setUser] = useState(null);

  // Handle tab click
  const handleTabSelect = (tab) => {
    setActiveTab(tab);
  };

  

 

  // Handle the response from Google
 

  // Handle form login
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState(''); // State for error messages
  const navigate = useNavigate(); // Hook for navigation

  // Hardcoded credentials
  const hardcodedEmail = 'admin@example.com';
  const hardcodedPassword = 'admin123';

  // Handle form login
  const handleFormLogin = (e) => {
    e.preventDefault();
    setErrorMessage(''); // Clear previous error messages

    // Check if credentials match
    if (email === hardcodedEmail && password === hardcodedPassword) {
      const userData = { email, role: 'admin' };
      onLogin(userData); // Notify parent component of successful login
      navigate('/dashboard'); // Redirect to AdminDashboard
    } else {
      setErrorMessage('Invalid credentials');
    }
  };

  return (
    <Container className="p-3 my-5 d-flex flex-column w-25">
      {/* Tabs for Login and Register */}
      <Tabs
        activeKey={activeTab}
        onSelect={handleTabSelect}
        id="auth-tabs"
        className="mb-3 justify-content-center"
      >
        <Tab eventKey="login" title="Login">
          {/* Login Form */}
          <Card>
            <Card.Body>
            

              <Form onSubmit={handleFormLogin}>
              <Form.Group className="mb-4">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter email"
                required
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                required
              />
            </Form.Group>

                <Row className="mb-4">
                  <Col>
                    <Form.Check type="checkbox" label="Remember me" />
                  </Col>
                  <Col className="text-end">
                    <a href="#!">Forgot password?</a>
                  </Col>
                </Row>

                <Button variant="primary" type="submit" className="w-100 mb-4">
                  Sign in
                </Button>

              
              </Form>
            </Card.Body>
          </Card>
        </Tab>

        
      </Tabs>
    </Container>
  );
}

export default AuthPage;